import Icon from '../components/Icon.vue'

Icon.register({
  'chart-pie': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M527.8 288H290.5L448.5 446C454.6 452.1 464.5 452.6 470.7 446.7 509.4 410.3 536 361.1 543.8 305.9 545.2 296.4 537.3 288 527.8 288zM512 223.2C503.7 103.7 408.3 8.3 288.8 0 279.7-0.6 272 7.1 272 16.2V240H495.8C504.9 240 512.6 232.3 512 223.2zM224 288V50.7C224 41.2 215.6 33.3 206.2 34.6 87 51.5-4.1 155.6 0.1 280.4 4.5 408.5 114.8 513.6 243 512 293.4 511.4 340 495.1 378.3 467.9 386.2 462.4 386.7 450.7 379.9 443.9L224 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chart-pie.js
// module id = ZHiG
// module chunks = 144